<template>
  <div>
    <div class="vx-row" v-if="device">
      <div class="vx-col w-full">
        <div class="article-title mb-6 text-center">
          <h1>{{ $t('ReleaseContent') }}</h1>

          <div class="bg-primary text-white mt-4 p-4 rounded" v-show="!dispositivo.licence.active">
            <div>{{ $t('TxtReleaseContentOne') }}</div>
            <div class="mt-4">
              {{ $t('TxtReleaseContentTwo') }}
              <strong> {{ $t('JustinTime') }} </strong> {{ $t('TxtPaymentTwo') }}
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full minwidth sm:w-1/2 xl:w-1/4 mb-4" v-for="plan in plans" :key="plan.id">
            <div :class="{ 'vx-card-black': plan.recurring == true, 'vx-card': plan.recurring == !true }">
              <div class="vx-card__collapsible-content vs-con-loading__container">
                <div class="p-8 clearfix">
                  <div>
                    <h2>
                      <span>{{ plan.name }}</span>
                      <img
                        v-if="plan.recurring == true"
                        src="../assets/images/elements/coroa.png"
                        width="20px;"
                        align="right"
                      />
                    </h2>
                    <small v-if="plan.discount && !plan.recurring">
                      <span class="text-grey mr-1"> {{ $t('Discount') }} </span>
                      <span class="mr-1">{{ plan.discount }}%</span>
                      <span>OFF</span>
                    </small>

                    <small v-if="!plan.discount && !plan.recurring">
                      <span>&nbsp;</span>
                    </small>

                    <small v-if="plan.recurring">
                      <span class="text-grey mr-1"> {{ $t('RecurringSubscription') }} </span>
                    </small>
                  </div>
                  <p class="mt-2 mb-8 font-medium" v-if="plan.setup_fee == 0">
                    <sup class="text-grey" v-if="plan.discount && !plan.recurring"> {{ $t('In') }} </sup>
                    <span
                      class="text-grey"
                      style="text-decoration: line-through; margin-right:15px;"
                      v-if="plan.discount && !plan.recurring"
                      >{{ plan.original_price | money(plan.currency_code) }}</span
                    >
                    <sup class="text-grey">{{ $t('Per') }}</sup>
                    <span class="ml-1 text-success text-xl">{{ plan.fixed_price | money(plan.currency_code) }}</span>
                  </p>
                  <p class="mt-2 mb-8 font-medium" v-if="plan.setup_fee > 0">
                    <sup class="text-grey"> {{ $t('Initial') }} </sup>
                    <span class="ml-1" style="margin-right:15px;">{{
                      plan.setup_fee | money(plan.currency_code)
                    }}</span>
                    <sup class="text-grey">{{ $t('Monthly') }}</sup>
                    <span class="ml-1 text-success text-xl">{{ plan.fixed_price | money(plan.currency_code) }}</span>
                  </p>
                  <a
                    :href="`${urlSite}/checkout/payment?planId=${plan.id}&k=${key}&d=${device}&eml=${email}`"
                    class="vs-component vs-button w-full vs-button-relief includeIcon"
                    :class="plan.recurring ? 'vs-button-warning' : 'vs-button-primary'"
                  >
                    <i
                      class="vs-icon notranslate icon-scale vs-button--icon feather icon-chevrons-right null"
                      style="order: 2; margin-right: 0px; margin-left: 5px;"
                    ></i>
                    <span class="vs-button-text vs-button--text" v-if="!plan.recurring"> {{ $t('BuyNow') }} </span>
                    <span class="vs-button-text vs-button--text" v-if="plan.recurring"> {{ $t('SubscribeNow') }} </span>
                  </a>
                </div>
                <div class="p-2 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                  <div class="vx-card__footer" style="padding-top:10px;">
                    <div class="flex justify-around">
                      <a :href="`https://api.whatsapp.com/send?phone=${appWhatsAppMobileNumber}`">
                        <span class="flex items-center">
                          <i class="fab fa-whatsapp"></i>
                          <span class="ml-2">WhatsApp</span>
                        </span>
                      </a>
                      <a :href="`tel:${appTelefoneNaoFormatado}`">
                        <span class="flex items-center">
                          <i class="fa fa-phone"></i>
                          <span class="ml-2">{{ $t('Telephone') }}</span>
                        </span>
                      </a>
                    </div>
                    <br />
                    <img
                      :src="`/assets/images/pages/${paymentCard}.png`"
                      alt=""
                      class="mx-auto h-8 img-wrapper"
                      v-if="!plan.recurring"
                    />
                    <img
                      :src="`/assets/images/pages/${paymentCardVip}.png`"
                      alt=""
                      class="mx-auto h-8"
                      v-if="plan.recurring"
                    />
                    <!-- aqui  -->
                    <div>
                      <div
                        class="flex lg:flex-row flex-col gap-y-4 p-2 items-start lg:items-start"
                        style="width: 100%; justify-content: space-between;"
                      >
                        <ul v-if="!plan.recurring">
                          <div>
                            <button
                              @click="toggleExpand(plan.id)"
                              class="btn-expand"
                              style="border: none; display: flex; align-items: center; background-color: transparent; font-size: 16px; font-weight: 500; color: #000; margin-bottom: 5px; margin-top: 10px; cursor: pointer;"
                            >
                              <img
                                src="@/assets/images/checkout/chevron-down.svg"
                                alt="check"
                                :class="[expandedPlan === plan.id ? 'rotated-actived' : 'rotated']"
                              />
                              Veja os recursos
                            </button>

                            <ul v-if="expandedPlan === plan.id">
                              <li v-for="(funcao, index) in funcoesAdicionais" :key="index">
                                <img
                                  src="@/assets/images/checkout/check-circle.svg"
                                  alt="check"
                                  style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                                />
                                {{ funcao }}
                              </li>
                            </ul>
                          </div>
                        </ul>
                        <ul v-else>
                          <div>
                            <button
                              @click="toggleExpand(plan.id)"
                              class="btn-expand"
                              style="border: none; display: flex; align-items: center; background-color: transparent; font-size: 16px; font-weight: 500; color: #fff; margin-bottom: 5px; margin-top: 10px; cursor: pointer;"
                            >
                              <img
                                src="@/assets/images/checkout/chevron-down-white.svg"
                                alt="check"
                                :class="[expandedPlan === plan.id ? 'rotated-actived' : 'rotated']"
                              />
                              Veja os recursos
                            </button>

                            <ul v-if="expandedPlan === plan.id">
                              <li v-for="(funcao, index) in funcoesVip" :key="index" class="text-sm">
                                <img
                                  src="@/assets/images/checkout/check-circle-white.svg"
                                  alt="check"
                                  style="width: 14px; height: 14px; color: #5c3498; display: inline-block; vertical-align: middle; margin-right: 8px;"
                                />
                                {{ funcao }}
                              </li>
                            </ul>
                          </div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.vx-card-black {
  background: black;
  width: 100%;
  border-radius: 0.5rem;
  display: block;
  -webkit-box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  color: aliceblue !important;
}

.vs-button-warning {
  background: #ffc306 !important;
}

.rotated {
  transform: rotate(-90deg); /* Rotaciona a imagem 90 graus */
  transition: transform 0.3s ease; /* Adiciona uma transição suave */
}

.rotated-actived {
  transform: rotate(0deg); /* Rotaciona a imagem 90 graus */
  transition: transform 0.3s ease; /* Adiciona uma transição suave */
}

.vx-card-black h2 {
  color: #ffc306;
}

.vx-card-black a {
  color: aliceblue;
}

.img-wrapper {
  clip-path: inset(0 70px 0 0);
  margin-left: -28px !important;
}
</style>

<script>
export default {
  data() {
    return {
      plans: [],
      device: '',
      key: '',
      email: '',
      urlSite: process.env.VUE_APP_URL_COMPRA,
      dispositivo: {
        licence: {
          until: null
        }
      },
      appTelefoneNaoFormatado: process.env.VUE_APP_TELEFONE_NAO_FORMATADO,
      appWhatsAppMobileNumber: process.env.VUE_APP_WHATSAPP,
      paymentCard: process.env.VUE_APP_PAYMENTCARD,
      paymentCardVip: process.env.VUE_APP_PAYMENTCARDVIP,
      expandedPlan: null,
      funcoesAdicionais: [
        'Teclas Digitadas',
        'Sites/Pesquisas',
        'Foto Remota',
        'Contatos',
        'WhatsApp',
        'Chamadas',
        'Escuta Ambiente',
        'Localização',
        'Instagram',
        'Fotos da Galeria',
        'SMS',
        'Modo invisível'
      ],
      funcoesVip: [
        'Todas as funções premium +',
        'Zona Segura',
        'Telegram',
        'Chamadas do WhatsApp',
        'Aplicativos Instalados',
        'Modo invisível'
      ]
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    load: function() {
      this.$api.get('/api/v1/mobile/device/' + this.$route.params.uid).then(response => {
        this.dispositivo = response.data.data;
        this.device = btoa(
          this.dispositivo.device + (this.dispositivo.alias ? ' (' + this.dispositivo.alias + ')' : '')
        );
        console.log('device', this.device);
      });

      this.$api
        .get(
          '/api/v1/plans/key/' + this.$route.params.uid + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')
        )
        .then(response => {
          this.key = response.data.key;
          this.email = response.data.eml;
        });

      this.$api.get('/api/v1/plans' + (this.$route.query.ip ? '?ip=' + this.$route.query.ip : '')).then(response => {
        this.plans = response.data.data.filter(i => {
          return i.product_id == this.$route.params.product_id;
        });
      });
    },
    toggleExpand(planId) {
      this.expandedPlan = this.expandedPlan === planId ? null : planId;
    }
  }
};
</script>
